import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP8NrOvw202606: FaireAdPerformancePeriodEntity = {
  token: "perf_p8_nr_ovw_202606",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-06-01",
  endDate: "2026-06-30",
  impressions: 84920,
  clicks: 1482,
  adsSpendDollars: 10085,
  budgetDollars: 15000,
  salesDollars: 48251,
  bestEstimateRoas: 4.78,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.67,
  newCustomersAcquired: 45,
  reorderConversions: 81,
  dataAvailableAtDate: "2026-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
